module.exports = function() {
  return new Worker(__webpack_public_path__ + "92ed9b0c827a903f82db.worker.js");
};